import LoginSuccess from "./login-success.container";

export default LoginSuccess;